import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import {
  Building2, Calendar, FolderOpen, Library, PenLine,
} from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import DocumentiStrutturaTab from "../components/documenti/DocumentiStrutturaTab";
import StampeMensiliTab from "../components/documenti/StampeMensiliTab";
import ModuliDaFirmareTab from "../components/documenti/ModuliDaFirmareTab";
import BibliotecaAffidyaTab from "../components/documenti/BibliotecaAffidyaTab";

const PAGE_BG = "#F8F9FA";

const TABS = [
  { value: "struttura", label: "Documenti Struttura", icon: Building2 },
  { value: "stampe", label: "Stampe Mensili", icon: Calendar },
  { value: "moduli", label: "Moduli da Firmare", icon: PenLine },
  { value: "biblioteca", label: "Biblioteca Affidya", icon: Library },
];

export default function Documenti() {
  const { token, hasPermission } = useAuth();
  const [activeTab, setActiveTab] = useState("struttura");

  return (
    <div className="min-h-screen" style={{ backgroundColor: PAGE_BG }}>
      <div className="mx-auto w-full max-w-[1920px] px-4 py-6 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-14">
        <PageHeader
          title="Documenti"
          subtitle="Documentazione e normative utili per la tua struttura."
          icon={FolderOpen}
          iconContainerClassName="bg-[#00A86B] shadow-sm"
          iconClassName="text-white"
        />

        <Tabs value={activeTab} onValueChange={setActiveTab} className="mt-6">
          <TabsList className="mb-6 h-auto w-full flex-wrap justify-start gap-1 rounded-xl border border-slate-200 bg-white p-1 shadow-sm">
            {TABS.map((tab) => {
              const Icon = tab.icon;
              return (
                <TabsTrigger
                  key={tab.value}
                  value={tab.value}
                  className="gap-2 rounded-lg px-4 py-2.5 data-[state=active]:bg-emerald-50 data-[state=active]:text-emerald-800 data-[state=active]:shadow-sm"
                  data-testid={`tab-documenti-${tab.value}`}
                >
                  <Icon className="h-4 w-4" />
                  <span className="hidden sm:inline">{tab.label}</span>
                  <span className="sm:hidden">{tab.label.split(" ")[0]}</span>
                </TabsTrigger>
              );
            })}
          </TabsList>

          <TabsContent value="struttura" className="mt-0">
            <DocumentiStrutturaTab token={token} hasPermission={hasPermission} />
          </TabsContent>

          <TabsContent value="stampe" className="mt-0">
            <StampeMensiliTab token={token} />
          </TabsContent>

          <TabsContent value="moduli" className="mt-0">
            <ModuliDaFirmareTab token={token} />
          </TabsContent>

          <TabsContent value="biblioteca" className="mt-0">
            <BibliotecaAffidyaTab token={token} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
